import React from "react";
import { ScrollView, View, Text } from "react-native";
import ResponsiveContent from "../shared/responsive-content";
import ProfileItemDivider from "./profile-item-divider";
import ProfileLogoutItem from "./profile-logout-item";
import { Avatar } from "../ui/avatar";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";
import { api } from "../utils/convex-api";
import Loader from "../shared/loader";

function StudentProfile() {
  const { data: studentProfile, isLoading } = useQuery(
    convexQuery(api.student.queries.getProfile, {})
  );
  const name = studentProfile?.firstName;
  const imageUrl = studentProfile?.imageUrl;
  const email = studentProfile?.email;

  if (isLoading) {
    return <Loader />;
  }

  return (
    <View className="flex-1 bg-teachLoop-creamBase">
      <ScrollView showsVerticalScrollIndicator={false}>
        <ResponsiveContent>
          <View className="h-3" />
          <View className="mx-5">
            <View className="gap-1">
              <Text className="font-zilla-slab-medium font-medium text-dark text-[32px] leading-[1.2]">
                Profile
              </Text>
            </View>
          </View>
          <View className="h-10" />
          <View className="mx-5 flex-row items-center gap-6 my-4">
            <Avatar size="md">
              <Avatar.Content
                label={name}
                labelSize="md"
                size="md"
                source={imageUrl ? { uri: imageUrl } : undefined}
              />
            </Avatar>
            <View>
              <Text className="font-geologica-medium font-medium text-gray-800 text-xl leading-[1.5]">
                {name}
              </Text>
              <Text className="font-geologica-regular font-normal text-gray-500 text-xl leading-[1.5]">
                {email}
              </Text>
            </View>
          </View>
          <ProfileItemDivider />
          <ProfileLogoutItem />
        </ResponsiveContent>
      </ScrollView>
    </View>
  );
}

export default StudentProfile;
